<template>
  <div class="container">
    <!--
    <div class="header">
      <div class="avatar">
        <svg-icon :icon-class="logo"/>
      </div>
      <div class="ai-title">{{ title }}</div>
      <div class="flex-1"></div>
    </div>
    -->
    <div class="chat-content">
      <div id="chatMessage">
        <div class="more-message btn-more" @click="getMessage(0)" v-if="showMore && messages.length > 0">查看更多</div>
        <div class="more-message empty-msg" v-if="messages.length == 0">暂无消息</div>
        <div v-for="(item, index) in messages" :key="index">
          <!-- 消息 -->
          <div :class="'msg-item '+ (item.is_robot == 0 ? 'item-right' : 'item-left' ) ">
            <div class="date" v-if="item.time">{{ item.time }}</div>
            <div class="msg-con">
              <!--              <img v-if=" item.is_robot == 0" class="user" src="@/assets/home/user.png">-->
              <svg-icon v-if=" item.is_robot == 0" class="user" icon-class="user"/>

              <template v-else>
                <svg-icon class="user-ai" :icon-class="logo"/>
              </template>
              <!-- 文本 -->
              <div class="content" v-if="item.content_type == 1">
                <img src="../../../assets/home/loading.gif" class="loading"
                     v-if="item.content == '' && isResposing == true && (index == messages.length -1)">
                <vue-markdown :source="item.content"></vue-markdown>

                <!--                <div v-html="item.content" v-else></div>-->
              </div>

              <!-- 图片 -->
              <div class="content img" v-if="item.content_type == 3" @click="previewImg(item.preview_url)">
                <img :src="item.content">
              </div>
              <!-- 视频 -->
              <div class="w355 h200 m-l-10" v-if="item.content_type == 5">
                <video class="w355 h200 b-r-4"
                       :src="item.preview_url"
                       controls="controls"></video>
              </div>
              <!-- 更多/删除 -->
              <div class="div-more" v-if="item.id > 0">
                <div class="icon-more " :class="'btn-copy'+item.id" @click="copy(item.id)"
                     :data-clipboard-text="filterHtml(item.content)">

                  <svg-icon icon-class="copy"></svg-icon>
                </div>
                <div class="icon-more" @click="delMessage(item.id, index)">
                  <svg-icon icon-class="trash"></svg-icon>
                </div>
              </div>
            </div>
            <!--            <div v-if="item.is_robot == 1 && isResposing == true && (index == messages.length -1)">停止生成</div>-->
            <div class="stop-gen" @click="stopGetResponse"
                 v-if="item.is_robot == 1 && isPrint == true && (index == messages.length -1)">
              停止输出
            </div>
            <div class="date clear-div" v-if="clearId > 0 && item.id == clearId">
              <div class="clear-line"></div>
              <div class="text">已清理上下文
                <el-popover
                    placement="bottom"
                    popper-class="msg-more-pop"
                    width="120"
                    trigger="click">
                  <svg-icon icon-class="more-grey" slot="reference"></svg-icon>
                  <div class="item" @click="delAll">清空聊天记录</div>
                </el-popover>
              </div>
              <div class="clear-line"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="footer">
      <div class="footer-con">
        <el-tooltip
            content="点击清理上下文可以重置AI状态，这样AI的回复会更加准确"
            :open-delay="500"
            placement="top-start">
          <img class="icon-clean" src="../../../assets/home/clean.png" @click="clear">
        </el-tooltip>
        <div class="input-div">
          <div class="input-con">
            <el-input v-model="msg" placeholder="请输入内容" type="textarea" resize="none"
                      :autosize="{ minRows: 1, maxRows: 8}"
                      @keydown.native="Keydown"></el-input>
          </div>
          <div :class=" msg ? 'btn-send has-content' : 'btn-send'" @click="sendMsg">
            <svg-icon icon-class="send"></svg-icon>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import {
  getMessages,
  sendMessage,
  delMessage,
  getNewMessages,
  clear,
  getResp,
  stopMessages,
  delAllMsg,
} from "@/api/aiTool";
import VueMarkdown from 'vue-markdown'
import {uuid} from "@/utils/index.js"
import Clipboard from 'clipboard'

export default {
  components: {VueMarkdown},
  props: ['aiId', 'title', 'logo'],
  data() {
    return {
      msg: '',
      last_id: 0,
      max_id: 0,
      messages: [],
      uploadName: '',
      upList: [],
      showViewer: false,
      viewerImgList: [],
      curMaxId: ',',
      clearId: '',
      showMore: true,
      timerRes: '',
      resIsDone: '',
      isResposing: '',
      curMessage: '',
      isStream: false,
      stopPrint: false,
      ws: '',
      fileId: '',
      mode: 1,
      stopGetNewMessage: false,
      avatar: '',
      isPrint: false,
      msgId: '',
    }
  },
  computed: {},
  created() {
    this.isStream = true
    this.getMessage()
  },
  mounted() {
    let div = document.getElementById("chatMessage")
    div.addEventListener('scroll', function () {
      div.click()
    });
  },
  watch: {
    aiId(value) {
      this.stopPrint = true
      clearInterval(this.timerRes);
      this.timerRes = ''
      this.stopGetNewMessage = true

      this.last_id = 0
      this.curMaxId = ''
      this.messages = []
      this.getMessage()

      switch (value) {
        case 10:
          this.isStream = false
          break;
        default:
          this.isStream = true
      }
    }
  },
  methods: {
    getMessage(scroll = 1) {
      let _this = this
      getMessages({last_id: this.last_id, ai_id: this.aiId}).then((res) => {
        if (res.data.list.length > 0) {
          _this.messages = res.data.list.concat(this.messages)
          _this.last_id = res.data.last_id
          if (res.data.max_id > _this.max_id) {
            _this.max_id = res.data.max_id
          }
          this.clearId = res.data.clear_id
          let count = res.data.list.length
          this.curMaxId = res.data.list[count - 1].id
          setTimeout(function () {
            if (scroll == 1) {
              _this.scrollView()
            }
          }, 500)
        } else {
          _this.showMore = false
        }
      })
    },
    //enter 键
    Keydown(e) {
      if (!e.shiftKey && e.keyCode == 13) {
        e.cancelBubble = true; //ie阻止冒泡行为
        e.stopPropagation();//Firefox阻止冒泡行为
        e.preventDefault(); //取消事件的默认动作*换行
        //以下处理发送消息代码
        this.sendMsg()
      }
    },
    //清空所有消息
    delAll() {
      delAllMsg({ai_id: this.aiId}).then((res) => {
        this.getMessage()
        this.messages = []
      })
    },
    //发送消息
    sendMsg() {
      this.stopPrint = false
      if (this.msg == '') {
        this.$message({
          type: 'warning',
          message: '请输入内容',
        })
        return false;
      }

      if (this.isResposing == true || this.isPrint == true) {
        return false
      }
      let msg = this.msg
      this.messages.push({
        id: '',
        is_robot: 0,
        content: msg,
        content_type: 1,
        time: ''
      })
      let _this = this
      setTimeout(function () {
        _this.scrollView()
      }, 200)
      _this.msg = ''
      let msgId = uuid(20);
      sendMessage({content: msg, ai_id: this.aiId, msg_id: msgId}).then((res) => {
        if (res.code == 429) {
          _this.reset()
          return;
        }
        if (res.code == -2) {
          //有敏感词
          _this.$message({
            type: 'warning',
            message: res.data,
          })
          _this.msg = msg
          _this.reset()
          if (_this.isStream == false) {
            _this.messages.splice(_this.messages.length - 1, 1)
          } else {
            _this.messages.splice(_this.messages.length - 2, 2)
          }
          return false
        } else if (res.code == -3) {
          this.$refs.limitDialog.open(3)
          setTimeout(function () {
            _this.reset()
          }, 1000)
          return false;
        }
        if (res.data.list.length > 0) {
          //删除最后一条消息
          if (_this.isStream == false) {
            _this.messages.splice(_this.messages.length - 1, 1)
            _this.messages = this.messages.concat(res.data.list)
            setTimeout(function () {
              _this.scrollView()
            }, 200)
          }
        }
      }).catch(error => {
        // this.$message({
        //   type: 'info',
        //   message: '网络开小差了，请刷新重试下哦~',
        // })
        _this.reset()
        return false;
      })

      //通用stream
      if (_this.isStream == true) {
        this.messages.push({
          id: '',
          is_robot: 1,
          content: '',
          content_type: 1,
          msg_id: msgId,
          time: ''
        })
        this.isResposing = true
        this.getResponse(msgId)
        this.msgId = msgId
        return true
      }
    },

    //轮询获取回复内容
    getResponse(id) {
      let _this = this
      let set = setInterval(() => {
        _this.doGetRes(id)
      }, 1000)

      this.timerRes = set
      this.resIsDone = false
      this.printWords()
    },
    //停止生成
    stopGetResponse() {
      console.log('停止生成--')
      stopMessages({ai_id: this.aiId, id: this.msgId}).then(res => {
        this.setNewMessageId()
      })
      this.reset()

    },
    reset() {

      console.log('reset')
      clearInterval(this.timerRes);
      this.timerRes = ''
      this.isResposing = false
      this.resIsDone = true
      this.stopPrint = true
      this.msgId = ''
    },

    doGetRes(id) {
      this.isResposing = true
      let _this = this
      getResp({id: id, ai_id: this.aiId})
          .then(function (result) {
            if (result.data.content != "") {
              _this.curMessage = result.data.content
            }
            if (result.data.is_done == 1) {

              clearInterval(_this.timerRes);
              _this.timerRes = ''
              _this.isResposing = false
              _this.resIsDone = true

            }
          });
    },
    setResponse(content) {
      let len = this.messages.length
      this.$set(this.messages[len - 1], 'content', content)
      this.scrollView()
    },
    setAppendResponse(content) {
      let len = this.messages.length
      let fullContent = this.messages[len - 1].content + content
      this.$set(this.messages[len - 1], 'content', fullContent)
      this.scrollView()
    },
    printWords() {
      this.isPrint = true
      var i = 1;
      let _this = this
      let count = 0
      var time = setInterval(function () {
        if (count > 5000) {
          //避免一直print
          clearInterval(time);
          _this.isPrint = false
          _this.curMessage = ''
        }
        count++
        if (_this.stopPrint == true) {
          clearInterval(time);
          _this.isPrint = false
          _this.curMessage = ''
        }

        //返回content 为空
        if (_this.resIsDone == true && _this.curMessage == '') {
          clearInterval(time);
          _this.isPrint = false
          _this.curMessage = ''
        }

        if (_this.curMessage.length >= i) {
          let text = _this.curMessage.substring(0, i);
          i = i + 1;
          _this.setResponse(text)
          if (_this.curMessage.length > 0 && text.length == _this.curMessage.length && _this.resIsDone == true) {
            clearInterval(time)
            _this.isPrint = false
            _this.curMessage = ''
            _this.setNewMessageId()
          }
        }
      }, 40)
    },
    //打印完毕 - set最新的消息的id
    setNewMessageId() {
      let _this = this
      getMessages({last_id: this.max_id, ai_id: this.aiId, filter: 'after'}).then((res) => {
        if (res.data.list.length > 0) {
          if (res.data.max_id > _this.max_id) {
            _this.max_id = res.data.max_id
          }
          _this.messages.forEach(function (item, index) {
            if (item.id == '') {
              _this.doSetMessageId(res.data.list, index, item)
            }
          })
        }
      })
    },
    doSetMessageId(list, index, msg) {
      let _this = this
      list.forEach(function (item) {
        if (item.content == msg.content || item.msg_id == msg.msg_id) {
          _this.$set(_this.messages[index], 'id', item.id)
        }
      })
    },

    //删除消息
    delMessage(id, index) {
      let _this = this
      delMessage({id: id}).then((res) => {
        if (res.data.clear_id > 0) {
          _this.clearId = res.data.clear_id
        }
      })
      this.messages.splice(index, 1)
      if (this.$refs[`pop${id}`] !== undefined) {
        this.$refs[`pop${id}`][0].doClose()
      }
    },
    filterHtml(text) {
      return text.replace(/<[^>]*>?/gm, '');
    },
    //复制消息
    copy(id) {


      let clipboard = new Clipboard('.btn-copy' + id)
      clipboard.on('success', (e) => {
        // 释放内存
        clipboard.destroy()
        this.$message('已复制到面板')
      })
      clipboard.on('error', (e) => {
        clipboard.destroy()
      })
    },

    //预览图片
    previewImg(url) {
      this.viewerImgList = [url]
      this.showViewer = true
    },
    //滚动页面
    scrollView() {
      let div = document.getElementById("chatMessage")
      if (div != undefined) {
        div.scrollTop = div.scrollHeight;
      }
    },
    //轮询get 消息:遍历15s
    getNewMessage(maxId, count = 0) {
      if (maxId < this.curMaxId || count > 15) {
        return false
      }
      let _this = this
      getNewMessages({max_id: maxId, ai_id: this.aiId}).then((res) => {
        if (res.data.count > 0) {
          _this.messages = _this.messages.concat(res.data.list)
          setTimeout(function () {
            _this.scrollView()
          }, 200)
        } else {
          setTimeout(function () {
            _this.getNewMessage(maxId, count + 1)
          }, 1000)
        }
      })
    },
    //清空上下文
    clear() {
      let _this = this
      clear({ai_id: this.aiId}).then((res) => {
        if (res.data.id) {
          _this.clearId = res.data.id
          _this.$message({
            type: 'success',
            message: '已清理上下文',
          })
          setTimeout(function () {
            _this.scrollView()
          }, 200)
        }
      })
    },
    getRandomNum() {
      let Min = 100000
      let Max = 999999
      let Range = Max - Min;
      let Rand = Math.random();
      return (Min + Math.round(Rand * Range));
    },
  },
}
</script>
<style lang="less">
.msg-more-opt {
  padding: 8px 0;
  min-width: 100px !important;
  border-radius: 10px;

  .line {
    height: 0.5px;
    background: #D6D8DC;
    margin: 8px 0;
  }

  .item {
    display: flex;
    height: 32px;
    align-items: center;
    cursor: pointer;

    &:hover {
      background: #f0f3f9;
    }

    img {
      width: 20px;
      height: 20px;
      margin: 0 12px 0 16px;
    }
  }
}

.msg-more-pop {
  min-width: 120px !important;
  padding: 0;
  border-radius: 10px;

  .item {
    width: 120px;
    height: 32px;
    line-height: 32px;
    padding: 0 0 0 16px;
    box-sizing: border-box;
    color: #000;
    font-size: 13px;
    cursor: pointer;
  }

}

.pro-gpt-dialog {
  .el-dialog__title {
    font-size: 14px;
    font-weight: 550;
  }

  .el-button--primary {
    background: #495CF7;
    width: 82px;
    height: 34px;
    border-radius: 10px;
  }

  .el-dialog__body {
    font-size: 12px;
    padding: 20px 30px;
  }
}

@supports (-webkit-touch-callout: none) {
  body {
    /* The hack for Safari */
    height: -webkit-fill-available;
  }
}

</style>
<style lang="less" scoped>
.container {
  display: flex;
  flex-direction: column;
  height: 100vh;
}

.header {
  display: flex;
  height: 60px;
  align-items: center;
  border-bottom: 1px solid #E2E4E9;
  background: #F8F9FA;

  .ai-title {
    font-size: 18px;
    font-weight: 600;
  }

  .avatar {
    width: 30px;
    height: 30px;
    background: #fff;
    margin: 0 10px 0 30px;

    img {
      width: 30px;
      height: 30px;
      border-radius: 4px;
    }

    .svg-icon {
      width: 30px;
      height: 30px;
      border-radius: 4px;
    }
  }

  .qrcode {
    width: 28px;
    height: 28px;
    background: #fff;
    border-radius: 10px;
    margin: 0 30px 0 0;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;

    .svg-icon {
      width: 18px;
      height: 18px;
    }
  }

  .disclaimer {
    color: #495CF7;
    font-size: 12px;
    cursor: pointer;
  }

  .mode-switch {
    padding: 4px 4px;
    border: 1px solid #D0D1D6;
    border-radius: 10px;
    margin: 0 30px 0 0;
    display: flex;
    align-items: center;
    justify-content: center;

    .item {
      width: 68px;
      height: 24px;
      font-size: 13px;

      cursor: pointer;
      display: flex;
      align-items: center;
      justify-content: center;
      border-radius: 6px;


      &.checked {
        background: #495CF7;
        color: #fff;
        font-weight: 550;
      }
    }
  }
}

.icon-eb {
  background: linear-gradient(-41deg, #1d6ff5, #9a7ffc);
  border-radius: 5px;
}

.chat-content {
  flex: 1;
  background: #F1F1F1;

  #chatMessage {
    overflow-y: auto;
    padding: 10px 0 40px 0;
    max-height: calc(100vh - 80px);
    //max-height: calc(var(--vh) * 100 - 80px);
    box-sizing: border-box;
    max-width: 792px;
    min-width: 375px;
    margin: 0 auto;
    flex: 1;
  }

  .clear-div {
    display: flex;
    align-items: center;
    padding: 20px 30px;
    box-sizing: border-box;

    .clear-line {
      flex: 1;
      height: 1px;
      background: #E2E4E9;
    }

    .text {
      margin: 0 20px;
      display: flex;
      align-items: center;

      .svg-icon {
        margin: 5px 0 0 6px;
        width: 16px;
        height: 16px;
        cursor: pointer;

        &:hover {
          background: #fff;
          border-radius: 2px;
        }
      }
    }
  }

  .more-message {
    width: 100%;
    text-align: center;
    cursor: pointer;
    color: #3E4551;

    &.btn-more {
      font-size: 13px;
    }
  }

  .empty-msg {
    color: #ADB1BA;
  }

  .msg-item {
    width: 100%;
    //margin: 20px 0 0 0;
    box-sizing: border-box;


    .date {
      width: 100%;
      height: 20px;
      font-size: 13px;
      color: #ADB1BA;
      text-align: center;
      line-height: 20px;
      margin: 0 0 20px 0;
    }

    .msg-con {
      width: 100%;
      display: flex;
      padding: 12px 0;

      .div-more {
        align-items: flex-end;
        display: none;
        cursor: pointer;

        .icon-more {
          width: 22px;
          height: 22px;
          border-radius: 6px;
          margin: 0 8px 0 0;
          background: #fff;
          display: flex;
          align-items: center;
          justify-content: center;

          svg {
            width: 18px;
            height: 18px;
          }
        }
      }

      .content {
        box-sizing: border-box;
        overflow: hidden;

        //图片样式
        /deep/ img {
          max-width: 100%;
        }

        //表格样式
        /deep/ table {
          border-collapse: collapse;

          th {
            background: #F3F5FC;
          }

          td, th {
            border: 1px solid #E5E5E5;
            padding: 4px 6px;
          }

          tr:first-child td,
          tr td:first-child,
          tr:first-child th,
          tr th:first-child {
            border-top: 1px solid #E5E5E5;
            border-left: 1px solid #E5E5E5;
          }

          tr td:last-child,
          tr th:last-child {
            border-bottom: 1px solid #E5E5E5;
            border-right: 1px solid #E5E5E5;
          }
        }

        //代码块的样式
        /deep/ pre {

          display: block;

          max-width: 100%;
          box-sizing: border-box;

          background: rgb(250, 250, 250);
          color: rgb(56, 58, 66);
          font-family: "Fira Code", "Fira Mono", Menlo, Consolas, "DejaVu Sans Mono", monospace;
          direction: ltr;
          text-align: left;
          white-space: pre;
          word-spacing: normal;
          word-break: normal;
          line-height: 1.5;
          tab-size: 2;
          hyphens: none;
          padding: 1em;
          margin: 0.5em 0px;
          overflow: auto;
          border-radius: 0.3em;

          code {
            max-width: 100%;
            white-space: pre-wrap !important;
            word-break: break-word !important;
            overflow: auto;
          }

        }


        letter-spacing: .5px;

        /deep/ p {
          margin: 0;
        }
      }
    }

    &.item-left .icon-more {
      margin: 0 0 0 8px !important;
    }

    .msg-con:hover .div-more {
      display: flex;
    }

    &.item-right .msg-con {
      flex-direction: row-reverse;
    }

    .content {
      max-width: calc(100% - 120px);
      color: #3E4551;
      font-size: 14px;
      line-height: 22px;
      background: #fff;
      padding: 6px 10px 8px 10px;
      box-sizing: border-box;
      border-radius: 10px;
      position: relative;
      display: flex;
      align-items: center;

      ::v-deep a {
        color: #6176A1 !important;
      }

      .loading {
        width: 30px;
      }

      .size {
        font-size: 11px;
        color: var(--unnamed, #787D86);
        line-height: 15px;
      }

      ::v-deep .file-icon .svg-icon {
        width: 40px;
        height: 40px;
      }
    }

    &.item-right .content {
      margin: 0 10px 0 0;
      background: #8CE97F;
      color: #10141B;
    }

    &.item-right .content.img {
      background: #fff;
      padding: 0;
      border: 0.5px solid var(--normal, #E2E4E9);
    }

    .content.img img {
      border-radius: 4px;
      cursor: pointer;
      max-width: 300px;
    }

    .content.file {
      padding: 8px 14px 8px 10px;
      background: #fff;
      border: 1px solid var(--normal, #E2E4E9);
      cursor: pointer;
    }

    &.item-left .content {
      margin: 0 0 0 10px;
      background: #ffffff;
      white-space: normal;

      div {
        /deep/ table {
          margin-bottom: 1em;
        }

        /deep/ p {
          max-width: 100%;
          white-space: pre-wrap !important;
          word-break: break-word !important;
          overflow: auto;
          margin-block-end: 1em;
        }

        /deep/ p:last-child {

          margin-bottom: 0;
          white-space: normal !important;
          margin-block-end: 0;
          display: block;

        }
      }
    }

    .user {
      width: 40px;
      height: 40px;
      margin: 0 10px 0 0;
      border-radius: 10px;
    }

    .user-ai {
      width: 40px;
      height: 40px;
      margin: 0 0 0 10px;
      border-radius: 10px;
      flex-shrink: 0;
    }

    .ai-name {
      color: #787D86;
      font-size: 11px;
      line-height: 19px;
    }

    .excel-list {
      margin: 10px 0 0 0;

      .file-item {
        width: 540px;
        height: 38px;
        background: #F8F9FA;
        border-radius: 6px;
        border: 0.5px solid #E2E4E9;
        margin: 0 0 10px;
        color: #10141B;
        font-size: 12px;
        line-height: 38px;
        display: flex;
        align-items: center;

        img {
          width: 22px;
          height: 22px;
          margin: 0 6px 0 12px;
        }
      }
    }
  }
}

.footer {
  width: 100%;
  min-height: 78px;
  box-sizing: border-box;
  background: #F1F1F1;
  align-items: center;
  padding: 0 0 30px;
  display: flex;
  display: -webkit-box; /* OLD - iOS 6-, Safari 3.1-6 */
  display: -moz-box; /* OLD - Firefox 19- (buggy but mostly works) */
  display: -ms-flexbox; /* TWEENER - IE 10 */
  display: -webkit-flex; /* NEW - Chrome */


  .input-div {
    display: flex;
    align-items: center;
    width: 100%;
    height: 50px;
    border-radius: 10px;
    border: 1px solid #D0D1D6;
    background: #fff;
    box-shadow: 0px 2px 12px 0px rgba(68, 73, 77, 0.13);
    margin: 0 10px 0 10px;
  }

  .footer-con {
    display: flex;
    align-items: center;
    width: 100%;
    max-width: 792px;
    min-width: 375px;
    margin: 0 auto;
  }

  .icon-clean {
    width: 22px;
    height: 22px;
    margin: 0 14px 0 14px;
    cursor: pointer;
  }

  .input-con {
    flex: 1;
    height: 48px;
    //margin: 20px 0;
    //height: 38px;
    background: #fff;
    border-radius: 10px;
    //border: 1px solid #4D5BDE;
    display: flex;
    align-items: center;
    //box-shadow: 0px 2px 12px 0px rgba(68, 73, 77, 0.13);

    ::v-deep .el-textarea__inner {
      padding: 8px 10px;
      border: none;
      border-radius: 10px;
      font-family: Helvetica, Arial, normal, 'PingFang SC';
      color: #3E4551;
    }


    .upd-file {
      width: 22px;
      height: 22px;
      margin: 0 10px 0 0;
      cursor: pointer;
    }
  }

  .btn-send {
    width: 40px;
    height: 40px;
    border-radius: 10px;
    margin: 0 5px 0 10px;
    background: #D0D1D6;
    color: #fff;
    cursor: pointer;
    font-size: 16px;
    font-weight: 500;
    display: flex;
    align-items: center;
    justify-content: center;

    &.has-content {
      background: #4D5BDE;
    }

    svg {
      width: 22px;
      height: 22px;
    }
  }


}

.stop-gen {
  width: 80px;
  height: 30px;
  color: #4D5BDE;
  line-height: 30px;
  text-align: center;
  border-radius: 10px;
  border: 1px solid #4D5BDE;
  margin: 0 0 0 60px;
  cursor: pointer;
}
</style>